import { CompanyInfo } from '../common/header/companyInfo'
import { Layout } from '../Layout'
import './lang/i18n'
import { NewsAndSocialContent } from './NewsAndSocialContent'

const NewsAndSocials = () => {
  return (
    <Layout
      renderTopComponent={() => <CompanyInfo />}
      renderBottomComponent={() => <NewsAndSocialContent />}
      isShowFooter={false}
    />
  )
}

export default NewsAndSocials
